













































































































































import Vue from 'vue';
import componentMixin from '@/utils/componentMixin';
import ContactForm from '@/components/contact-form/ContactForm.vue';
export default Vue.extend({
	mixins: [componentMixin],
	components: {
		ContactForm,
	},
});
